// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { TenantRole } from "./TenantRole";
import {
  TenantRoleFromJSON,
  TenantRoleFromJSONTyped,
  TenantRoleToJSON,
  TenantRoleToJSONTyped,
} from "./TenantRole";

/**
 *
 * @export
 * @interface UserUpdate
 */
export interface UserUpdate {
  /**
   *
   */
  role?: TenantRole | null;
  /**
   *
   */
  active?: boolean | null;
}

/**
 * Check if a given object implements the UserUpdate interface.
 */
export function instanceOfUserUpdate(value: object): value is UserUpdate {
  return true;
}

export function UserUpdateFromJSON(json: any): UserUpdate {
  return UserUpdateFromJSONTyped(json, false);
}

export function UserUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserUpdate {
  if (json == null) {
    return json;
  }
  return {
    role:
      json["role"] === undefined
        ? undefined
        : json["role"] === null
        ? null
        : TenantRoleFromJSON(json["role"]),
    active:
      json["active"] === undefined ? undefined : json["active"] === null ? null : json["active"],
  };
}

export function UserUpdateToJSON(json: any): UserUpdate {
  return UserUpdateToJSONTyped(json, false);
}

export function UserUpdateToJSONTyped(
  value?: UserUpdate | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    role: TenantRoleToJSON(value["role"]),
    active: value["active"],
  };
}
